import { Outlet } from "react-router-dom";
import { SWRConfig } from "swr";
import { fetcher } from "../../api/utils";
import Navbar from "../Navbar";

export default function Layout() {
    return (
        <SWRConfig value={{ fetcher: fetcher }}>
            <div
                className={`font-open-sans has-[.isWhitePage]:bg-white bg-blue-light flex flex-col min-h-screen`}
            >
                <Navbar />
                <div className={`w-full mx-auto px-3 pt-3 xl:px-5 xl:pt-5`}>
                    <Outlet />
                </div>
            </div>
        </SWRConfig>
    );
}
